module.exports = __webpack_public_path__ + "img/totalCount.4e34b102.png";